import { type MenuItem } from '@v2/shared/lib/types';
import { SpecialDealLink, FullScreenDialog } from '@v2/brands/discountmags/Layouts/Full/Navigation';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
  closeMainMenu: () => void;
  specialDealLinks: MenuItem[];
};

export default function SpecialDealsDialog({ isOpen, toggle, close, closeMainMenu, specialDealLinks }: Props) {
  return (
    <FullScreenDialog
      slideInFrom="right"
      isOpen={isOpen}
      toggle={toggle}
      close={() => {
        close();
        closeMainMenu();
      }}
      title="Special Deals"
      showBackButton
      onBack={close}
    >
      <div className="text-lg font-semibold px-4 py-3 border-b-[1.5px] border-slate-100">All Special Deals</div>
      <div className="grid grid-cols-3 gap-4 px-4 py-4">
        {specialDealLinks.map(({ id, href, title, icon, priceIcon }) => (
          <SpecialDealLink key={id} href={href} title={title} icon={icon} priceIcon={priceIcon} />
        ))}
      </div>
    </FullScreenDialog>
  );
}
